import React from "react"
import { Container, Title } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/GotvV2Form.styles"

interface GotvV2FormProps {
    campaign: any
    t: (key: string) => string
    uniqueWidgetId: string
    isSubmitting?: boolean
    postGrassrootsSupporterAction: (payload: any) => void
    styledButtonText: string
}

export const GotvV2Form: React.FC<GotvV2FormProps> = ({ campaign }) => {
    return (
        <Container className="gotv-v2-campaign-main">
            <Title>{campaign.name}</Title>
            <p>GOTV V2 Campaign - Coming Soon</p>
            {/* TODO: Add campaign implementation here */}
        </Container>
    )
}
